import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
// import { NGXLogger } from 'ngx-logger';
import { Overlay } from 'ol';
import { Coordinate } from 'ol/coordinate';
import { getCenter, Extent } from 'ol/extent';
import { Observable, of, throwError } from 'rxjs';
import { map, mergeMap, shareReplay, switchMap } from 'rxjs/operators';
import { ConfigApiInterface, WorldInfoInterface } from 'src/app/home/object-info/model/config-api-response.interface';
import { NamApiResponse, SelectByUrnsResponse } from 'src/app/home/object-info/model/nam-api-response.interface';
import { NamObjectTemplate, NamObjectTemplates } from 'src/app/home/object-info/model/nam-object-template.interface';
import { RelatedItemsInterface } from 'src/app/home/object-info/model/related-item.interface';
import { extractRelatedItems } from 'src/app/home/object-info/object-utils';
import { MapService } from 'src/app/library/ebw-map-angular/service/map.service';
// import { ConfigService } from '../config/config.service';
// import { GestioneLoginService } from '../login/gestione-login.service';
import { MappaService } from '../mappa/mappa.service';
import { UtilsService } from '../utils.service';
import { ProjectService } from './project.service';
import { WorldService } from './world.service';

@Injectable({
  providedIn: 'root',
})
export class NamService {
  private cacheNamConfigApi$: Observable<ConfigApiInterface>;

  constructor(
    private utils: UtilsService,
    private mapService: MapService,
    private sanitizer: DomSanitizer,
    private projectService: ProjectService,
    private wrapperMapService: MappaService
  ) {}

  namPopup: Overlay;
  namPopupContent: any[] = ["hack"];
  coordinatePopup: Coordinate;

  popupIsOpen: boolean = false;

  // todo : make interface for response type
  selectObjectByUrn(urn: string): Observable<NamApiResponse<unknown>> {
    let url = this.utils.creaURL('restrictedArea', 'selectByUrn');
    // console.log("DE RES", urn, this.loginServ.getToken());
    if (urn) {
      // todo: refactor create params
      url += '?urn=' + urn;
      url += this.projectService.projectId ? '&project_id=' + this.projectService.projectId : '';
      url += '&application=nam';

      return this.utils.getRequest(url, {}) as Observable<NamApiResponse<unknown>>;
    } else {
      return of(null);
    }
  }

  // should it be here ?
  openPopup(coordinate: Coordinate) {
    //content.innerHTML = '<p>You clicked here:</p><code>' + hdms + '</code>';
    this.wrapperMapService.mappa.insertOverlay(this.namPopup);
    this.namPopup.setPosition(coordinate);
    this.coordinatePopup = coordinate;
    this.popupIsOpen = true;
  }

  // should it be here ?
  closePopup() {
    if (this.namPopup) {
      this.namPopup.setPosition(undefined);
    }
    this.popupIsOpen = false;
  }

  // Returns all features lying in the provided coordinate by calling restrictedArea/select.
  selectByCoordinate(latitude: number, longitude: number, worldInfo: WorldInfoInterface, _hitRadius?: number): Observable<NamApiResponse<unknown>> {
    let hitRadius = _hitRadius ?? 5;
    let url = this.utils.creaURL('restrictedArea', 'select');

    //hit_radius=5&lng=12.914616&lat=43.915135
    let params = {};
    params["hit_radius"] = hitRadius; // hard coded for the moment
    params["coord_y"] = longitude; //hard coded for the moment
    params["coord_x"] = latitude; //hard coded for the moment
    params["project_id"] = this.projectService.projectId;
    params["application"] = "nam";
    //params["lng"] = latitude; //hard coded for the moment
    //params["lat"] = longitude; //hard coded for the moment
    params["crs"] = worldInfo.crs
    params["world_urn"] = worldInfo.world_urn;  //world urn is used for internal elements

    return this.utils.getRequest(url, params) as Observable<NamApiResponse<unknown>>;
  }

  getApiConfiguration(): Observable<ConfigApiInterface> {
    if (!this.cacheNamConfigApi$) {
      let url = this.utils.creaURL('restrictedArea', 'config');
      // todo: extract param from config globale
      const body = new HttpParams().append('application', 'nam');
      const headers = new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded');
      this.cacheNamConfigApi$ = (
        this.utils.postRequest(url, body, false, { headers }) as Observable<ConfigApiInterface>
      ).pipe(shareReplay(1));
    }
    return this.cacheNamConfigApi$;
  }

  getSelectByUrns(urns: string[]): Observable<SelectByUrnsResponse>{
    let url = this.utils.creaURL('restrictedArea', 'selectByUrns');
    const urnListString = urns.join(",");

    const body = new HttpParams()
    .append('urns', urnListString)
    .append('application', 'nam')
    .append('project_id', this.projectService.projectId);
    const headers = new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded');

    return this.utils.postRequest(url, body, false, {headers}) as Observable<SelectByUrnsResponse>;
  }

  // todo: should it be here?
  getObjectByUrnAndRelatedItems(urn: string): Observable<{
    response: NamApiResponse<{}>;
    relatedItems: RelatedItemsInterface;
  }> {
    return this.getApiConfiguration().pipe(
      switchMap((configAPI) =>
        this.selectObjectByUrn(urn).pipe(
          mergeMap((res) => {
            // todo : ? type of res, handle Error case ...
            return !res || (res.error && res.error != 0)
              ? throwError(() => new Error(res.message))
              : of({
                response: res,
                relatedItems: extractRelatedItems(res.result ? res.result : res.data, configAPI),
              })
          }
          )
        )
      )
    );
  }

  getSelectedCoordinatesFromMapService() {
    return this.mapService.coordinateSelezionate$;
  }

  getTemplates(urn: string): Observable<NamApiResponse<NamObjectTemplates>> {
    const url = this.utils.creaURL('template', 'list');
    const params = { urn: [urn] };
    return this.utils.getRequest(url, params) as Observable<NamApiResponse<NamObjectTemplates>>;
  }

  placeTemplate(bbox: Extent, angle: number, worldId: string, projectId: string, template: NamObjectTemplate, properties: string){
    const url = this.utils.creaURL('project', 'placeTemplate');
    let parameters = {};
    parameters["project_id"] = projectId;
    parameters["world_id"] = worldId;
    parameters["world_urn"] = worldId;
    parameters["template_name"] = template.name.split('+').join("&&&");
    parameters["template_type"] = template.collection;
    parameters["coord_x"] = bbox[0]; //minx
    parameters["coord_y"] = bbox[1]; //miny
    parameters["orientation"] = angle;
    parameters["properties"] = properties; //JSON string

    return this.utils.getRequest(url, parameters) as Observable<NamApiResponse<{urn: string}>>;
  }

  getTemplateImage(name: String, collection: string): Observable<null | SafeUrl> {
    const url = this.utils.creaURL('template', 'preview');
    const params = { name: [name.split('+').join("&&&")], type: [collection] };
    const responseType = { responseType: 'blob' };

    return (this.utils.getRequest(url, params, responseType) as Observable<Blob | NamApiResponse<null>>).pipe(
      map(response => (response as NamApiResponse<null>)?.error ? null : this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(response as Blob)))
    );
  }

  // todo: response type
  deleteFeature(urn: string, projectId: string, worldUrn): Observable<NamApiResponse<any>>{
    let url = this.utils.creaURL('feature', 'delete');
    let params = {};
    params['project_id'] = projectId;
    params['world_urn'] = worldUrn;
    params['feature'] = JSON.stringify({ type: 'Feature', id: urn });
    return this.utils.getRequest(url, params) as Observable<NamApiResponse<any>>;
  }

  // todo: response type
  updateFeature(urn: string, body, projectId: string, worldUrn: string): Observable<NamApiResponse<any>> {
    let url = this.utils.creaURL('feature', 'update');
    let params = {};
    params['project_id'] = projectId;
    params['world_urn'] = worldUrn;
    params['feature'] = JSON.stringify({
      type: 'Feature',
      id: urn,
      properties: body,
    });
    return this.utils.getRequest(url, params) as Observable<NamApiResponse<any>>;
  }

  getEditsInProject(projectId: string){
    let url = this.utils.creaURL('project', 'editsInProject');
    let params = {};
    params['project_id'] = projectId;
    return this.utils.getRequest(url, params);
  }

  moveFeatureEdit(bbox: Extent, worldId: string, urn: string, projectId: string){
    const url = this.utils.creaURL('feature', 'move');
    let parameters = {};
    parameters["project_id"] = projectId;
    parameters["world_urn"] = worldId;
    parameters["urn"] = urn;
    // Center of the extent of the geometry.
    parameters["coord_x"] = getCenter(bbox)[0];
    parameters["coord_y"] = getCenter(bbox)[1];
    parameters["application"] = "nam";
    parameters["relative_position"] = "false";

    return this.utils.getRequest(url, parameters) as Observable<NamApiResponse<{urn: string}>>;
  }

  rotateFeatureEdit(rotationAngle: number, worldId: string, urn: string, projectId: string){
    const url = this.utils.creaURL('feature', 'rotate');
    let parameters = {};
    parameters["project_id"] = projectId;
    parameters["world_urn"] = worldId;
    parameters["urn"] = urn;
    parameters["rotation_degree"] = rotationAngle; //in degrees
    parameters["application"] = "nam";

    return this.utils.getRequest(url, parameters) as Observable<NamApiResponse<{urn: string}>>;
  }
}
